const mapAvailableOrder = order => ({
  id: order.id,
  number: order.number,
  date: order.date,
  external_url: order.external_url,
})

const mapProduct = product => ({
  id: product.id,
  name: product.name,
  image_url: product.image_url,
})

const mapVariant = variant => ({
  id: variant.id,
  title: variant.title,
  sku: variant.sku,
  options: variant.options,
  image_url: variant.image_url,
})

const mapUnexpectedItem = item => ({
  id: item.id,
  name: item.name,
  sku: item.sku,
  product: item.product ? mapProduct(item.product) : item.product,
  variant: item.variant ? mapVariant(item.variant) : item.variant,
  available_orders: item.available_orders ? item.available_orders.map(mapAvailableOrder) : item.available_orders,
})

export const transformResponseGetUnexpectedItems = items => (items ? items.map(mapUnexpectedItem) : items)

const mapAssignment = assignment => ({
  unexpected_item_id: assignment.unexpected_item_id,
  action: assignment.action,
  target_order_id: assignment.target_order_id,
})

export const transformRequestConfirmUnexpectedItems = ({ returnId, assignments }) => ({
  returnId,
  payload: {
    assignments: assignments.map(mapAssignment),
  },
})
